export const MAX_CONSENT_FORM_FILE_BYTES = 10 * 1024 * 1024;
export const MAX_CONSENT_FORM_VALIDITY_MONTHS = 120;

export const ConsentFormStatus = {
  Active: 'Active',
  Archived: 'Archived',
};

export const ConsentContextType = {
  Booking: 'Booking',
  ServicePackagePurchase: 'ServicePackagePurchase',
  MembershipPurchase: 'MembershipPurchase',
  PendingRequest: 'PendingRequest',
};

export const isConsentFormActive = (form) => form?.status === ConsentFormStatus.Active;
